"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardBody = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _PropertyCardBody = require("./PropertyCardBody.styles");
/**
 * Used to add card styles and behaviors to the `PropertyCard`. Extends `Card`.
 *
 * @extends Card
 * @since 8.63.0
 */
var PropertyCardBody = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_PropertyCardBody.StyledPropertyCardBody, (0, _extends2.default)({
    ref: forwardedRef,
    appearance: "borderless",
    cardType: "secondary"
    /* Override role="button" applied by Card. Can't have buttons inside of a button. */,
    role: undefined
  }, props));
});
exports.PropertyCardBody = PropertyCardBody;
PropertyCardBody.displayName = 'PropertyCard.Body';